<vc-ref
  *ngIf="seller"
  [anchor]="false"
  resource="/members/profile-{{ seller.id }}.shtml"
  (click)="stopPropagation($event)"
  class="sellerBadge"
>
  <span
    *ngIf="hasImg"
    class="sellerBadge__img"
    [style.backgroundImage]="'url(' + getImage(seller.picture.path) + ')'"
  ></span>
  <span *ngIf="!hasImg" class="sellerBadge__img firstLetter">{{ firstLetter }}</span>
</vc-ref>
